<div class="padding">
  <div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">
    <div class="carousel-inner">
      <div class="panel panel-default">
        @if(isLoadingResults){
          <div class="example-loading-shade">
            @if(isLoadingResults){
              <mat-spinner diameter="30"></mat-spinner>
            }
          </div>
        }
        <div class="panel-heading">
          <p class="panel-title">
            CAT ROE's By Source {{ LastCATExecutionDate | date:'dd' }} - {{ LastCATExecutionDate | date:'MMM' }} </p>
        </div>
        <div class="col-lg-12 nopadding">
          <div class="panel-body nopadding">
            <div style="display: block;  max-height: 275px !important;">
              <canvas style="display: block;
              max-height: 275px !important;
              min-height: 275px !important;
              padding: 19px;
              width: 412px;" baseChart
              [data]="chartData"
              [options]="barChartOptions" 
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>